import { userAvailabilityForRange } from '@uplift/api';
import { DateFormats } from '@uplift/constants';
import { CalendarDateService } from '@uplift/services';
import { asyncWait } from '@uplift/utils';
import { useQuery } from '@tanstack/react-query';


export const useAvailabilityData = (date: string, timezone: string) => {
  return useQuery(
    [ 'calendar', date, 'availability' ] as const,
    async ({ queryKey: [ _, date ] }) => {
      const dateTime = CalendarDateService.date.tz(date, DateFormats.ISO_DATE, timezone);
      const start = dateTime.startOf('day').utc().format();
      const end = dateTime.endOf('day').utc().format();

      const [ response ] = await Promise.all([
        userAvailabilityForRange({
          datetime_from: start,
          datetime_to: end,
        }),
        asyncWait(300),
      ]);

      return response;
    }
  );
};
